import { useNavigateToKind } from './useNavigateToKind'

// TODO: Rename this component to be consistent with FrameGroup
// https://linear.app/sketch/issue/WEB-500/rename-common-components-between-artboards-and-frames-to

/**
 * Returns a navigateToFrame callback that opens a frame from the canvas, on
 * whichever host owns the document.
 */
export function useNavigateToFrame() {
  return useNavigateToKind('frame')
}
